import dynamic from "next/dynamic";

import StocksHeroSection from "@/components/Stocks/StocksHeroSection";
import StockBarSection from "@/components/Stocks/StockBarSection";
import MarketsSection from "@/components/Stocks/MarketsSection";
import SharksSection from "@/components/Stocks/SharksSection";
import ScreenersSection from "@/components/Stocks/ScreenersSection";
import ResultsSection from "@/components/Stocks/ResultsSection";
import NewsSection from "@/components/Stocks/NewsSection";
// import BrokersSection from "@/components/Stocks/BrokersSection";
import MetaSection from "@/elements/MetaSection/MetaSection";
import { useContext, useEffect } from "react";
import { Mixpanel } from "@/elements/Mixpanel";
import { UserDetailProvider } from "@/contexts/UserDetailContext";
import WidgetViewed from "@/elements/WidgetViewed";
import { useRouter } from "next/router";

// const BrokersSection = dynamic(() => import('@/components/Stocks/BrokersSection'))
// const NewsSection = dynamic(() => import('@/components/Stocks/NewsSection'))
// const ResultsSection = dynamic(() => import('@/components/Stocks/ResultsSection'))
// const ScreenersSection = dynamic(() => import('@/components/Stocks/ScreenersSection'))
// const SharksSection = dynamic(() => import('@/components/Stocks/SharksSection'))
// const IdeasSection = dynamic(() => import('@/components/Stocks/IdeasSection'))
// const MarketsSection = dynamic(() => import('@/components/Stocks/MarketsSection'))

export default function Stocks() {
    const router = useRouter();
    const userDetail = useContext(UserDetailProvider);
    useEffect(() => {
        Mixpanel.pageView({
            page: "stocks_home"
        });
        userDetail.setBtn({
            show: true,
            beforeLogin: "Get started",
            afterLogin: "Download the app now",
            isProPage: true,
            page: "stocks_home"
        });
    }, []);
    return (
        <>
            <MetaSection
                title="Stock Analysis, Exit Investment, Investment Ideas, Market Research, News | Univest"
                desc="SEBI registered stock market platform with free portfolio analyis, easy research, investment ideas, stock market tips, live share market, latest news and screeners"
                keyWords="bombay stock exchange, Indian stock market, bse, national stock exchange, Nifty, nse, sensex, stock exchange, stock market, stock research tool, smart investment, investment ideas, stock market tips"
                schema={{
                    "@context": "https://schema.org",
                    "@graph": [
                        {
                            "@type": "BreadcrumbList",
                            "@id": `https://univest.in${router?.asPath}`,
                            itemListElement: [
                                {
                                    "@type": "ListItem",
                                    position: 2,
                                    name: "Stock",
                                    item: "https://univest.in/stocks"
                                }
                            ]
                        },
                        {
                            "@type": "Organization",
                            "@id": "https://univest.in/#organization",
                            url: "https://univest.in/stocks",
                            name: "Univest",
                            logo: "https://storage.googleapis.com/app-assets-univest/website-assets/UnivestLogo.jpg",
                            address: {
                                "@type": "PostalAddress",
                                addressLocality: "Gurugram, Haryana",
                                postalCode: "122002",
                                streetAddress: "10, Poorvi Marg, DLF Phase 2, Sector 25, Gurugram, Haryana 122002"
                            },
                            email: "support@univest.in",
                            telephone: "+91-8800049790",
                            sameAs: [
                                "https://www.facebook.com/Univest.in",
                                "https://www.instagram.com/univest.in/",
                                "https://twitter.com/UnivestIN",
                                "http://linkedin.com/company/univest-in",
                                "https://www.youtube.com/channel/UCRlFx-WxA4yY7Y33SRZaQ4w",
                                "https://www.crunchbase.com/organization/univest-557f"
                            ],
                            contactPoint: [
                                {
                                    "@type": "ContactPoint",
                                    telephone: "+91-8800049790",
                                    contactType: "Customer Service"
                                }
                            ],
                            foundingDate: "2022",
                            founders: [
                                {
                                    "@type": "Person",
                                    name: "Pranit Arora",
                                    id: "https://in.linkedin.com/in/pranit-arora-1b505422"
                                },
                                {
                                    "@type": "Person",
                                    name: "Avneet Dhamija",
                                    id: "https://in.linkedin.com/in/avneet-dhamija"
                                },
                                {
                                    "@type": "Person",
                                    name: "Vikash Agarwal",
                                    id: "https://in.linkedin.com/in/vikashagrawal1985"
                                }
                            ],
                            funder: {
                                "@type": "Corporation",
                                legalName: "Trinity media Group",
                                url: "https://www.vccircle.com/company/trinity-media-group"
                            }
                        },
                        {
                            "@type": "Product",
                            "@id": "https://univest.in/stocks/#product",
                            name: "Stock Advisory service In India",
                            url: "https://univest.in/stocks",
                            image: "",
                            review: [
                                {
                                    "@type": "Review",
                                    reviewBody:
                                        "I like Today's Gainers and Today's Losers in Discover in the Invest section.It helps me plan which Stocks should I invest and which I should not",
                                    author: { "@type": "Person", name: "Baradi Shivakumar" },
                                    reviewRating: { "@type": "Rating", ratingValue: "4.9" },
                                    datePublished: "2023"
                                },
                                {
                                    "@type": "Review",
                                    reviewBody:
                                        "I like the Portfolio News in the Invest section on the univest App. It shows News related to the Stocks that are in my Portfolio which helps me in keeping a track of my Stocks status",
                                    author: { "@type": "Person", name: "Naman Nema" },
                                    reviewRating: { "@type": "Rating", ratingValue: "4.9" },
                                    datePublished: "2023"
                                },
                                {
                                    "@type": "Review",
                                    reviewBody:
                                        "I like the option chain section and the way Greeks are displayed as it is very simple to track and make decision to execute orders. It is also easy to buy and sell positions, UI is very nice.",
                                    author: { "@type": "Person", name: "Shiva singh" },
                                    reviewRating: { "@type": "Rating", ratingValue: "4.9" },
                                    datePublished: "2022"
                                },
                                {
                                    "@type": "Review",
                                    reviewBody: "Where trust matters univest never breaks.",
                                    author: { "@type": "Person", name: "Jatin" },
                                    reviewRating: { "@type": "Rating", ratingValue: "4.9" },
                                    datePublished: "2023"
                                },
                                {
                                    "@type": "Review",
                                    reviewBody:
                                        "The ROS feature is very good and can help the budding option traders to learn with proper discipline and risk management.",
                                    author: { "@type": "Person", name: "Pandi Donald" },
                                    reviewRating: { "@type": "Rating", ratingValue: "4.9" },
                                    datePublished: "2023"
                                },
                                {
                                    "@type": "Review",
                                    reviewBody:
                                        "I have been using univest for over 5 years now and it has provided me with an awesome experience and excellent customer support. Thanks to univest, I have also gained a lot of knowledge about stock market.",
                                    author: { "@type": "Person", name: "Prabhakar Dutta" },
                                    reviewRating: { "@type": "Rating", ratingValue: "4.9" },
                                    datePublished: "2023"
                                },
                                {
                                    "@type": "Review",
                                    reviewBody:
                                        "I like the Portfolio News in the Invest section on the univest App. It shows News related to the Stocks that are in my Portfolio which helps me in keeping a track of my Stocks status",
                                    author: { "@type": "Person", name: "Pandi Donald" },
                                    reviewRating: { "@type": "Rating", ratingValue: "4.9" },
                                    datePublished: "2023"
                                }
                            ],
                            brand: "univest",
                            description:
                                "Start Trading in Share Market, SIP, IPOs, Mutual Fund, Indices and Commodity at univest.in with hassle free process.",
                            aggregateRating: {
                                "@type": "AggregateRating",
                                ratingValue: "4.4",
                                ratingCount: "230120",
                                reviewCount: "197000"
                            }
                        },
                        {
                            "@type": "WebPage",
                            "@id": "https://univest.in/#webpage",
                            name: "Stock Analysis, Exit Investment, Investment Ideas, Market Research, News | Univest",
                            description:
                                "SEBI registered stock market platform with free portfolio analyis, easy research, investment ideas, stock market tips, live share market, latest news and screeners",
                            keywords:
                                "bombay stock exchange, Indian stock market, bse, national stock exchange, Nifty, nse, sensex, stock exchange, stock market, stock research tool, smart investment, investment ideas, stock market tips",
                            speakable: {
                                "@type": "SpeakableSpecification",
                                cssSelector: [
                                    "Stock Analysis, Exit Investment, Investment Ideas, Market Research, News | Univest",
                                    "SEBI registered stock market platform with free portfolio analyis, easy research, investment ideas, stock market tips, live share market, latest news and screeners"
                                ]
                            },
                            url: `https://univest.in${router?.asPath}`
                        }
                    ]
                }}
            />
            <StocksHeroSection homePage={false} />
            <StockBarSection />
            <WidgetViewed eventName="widget_scrolled" data={{ page: "web_stock", widget: "stock_markets", depth: 1 }}>
                <MarketsSection />
            </WidgetViewed>
            {/* <IdeasSection /> */}
            <WidgetViewed
                eventName="widget_scrolled"
                data={{ page: "web_stock", widget: "stock_sharkportfolio", depth: 2 }}
            >
                <SharksSection />
            </WidgetViewed>
            <ScreenersSection />
            <WidgetViewed eventName="widget_scrolled" data={{ page: "web_stock", widget: "stock_results", depth: 3 }}>
                <ResultsSection />
            </WidgetViewed>
            {/* <NewsSection /> */}
            {/* <WidgetViewed
                eventName="widget_scrolled"
                data={{ page: "web_stock", widget: "stock_link_account", depth: 4 }}
            >
                <BrokersSection />
            </WidgetViewed> */}
        </>
    );
}
